module.exports = __webpack_public_path__ + "static/media/facebook_buton.6c042e8e.png";